import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {IAppConfig} from "./context/AppMenuProvider";

const root = ReactDOM.createRoot(
  document.getElementById('mr-enhanced-menu') as HTMLElement
);

const readConfig = (element: any): IAppConfig => {
    const configDataString = element.getAttribute("data-config") || "{}";
    const config = JSON.parse(configDataString);

    return config as IAppConfig;
};

const element = document.getElementById("mr-enhanced-menu");
const appConfig = readConfig(element);

root.render(
  <React.StrictMode>
    <App config={appConfig}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
